/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Gym_SearchInputs */

const en_features_gym_search = /** @type {(inputs: Features_Gym_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search gyms`)
};

const pl_features_gym_search = /** @type {(inputs: Features_Gym_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szukaj siłowni`)
};

/**
* | output |
* | --- |
* | "Search gyms" |
*
* @param {Features_Gym_SearchInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_gym_search = /** @type {((inputs?: Features_Gym_SearchInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Gym_SearchInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_gym_search(inputs)
	return en_features_gym_search(inputs)
});